// ============================================================================
// pwa-links-client-mod -- 注册器
//
// 1. 注册业务服务到 IClientServiceRegistryService（供 React Context 消费）
// 2. 注册公开导航页面路由 /pwa-links（带 SSR loader）
// 3. 注册 Admin Slot 到 admin-client-mod
// ============================================================================
import { PwaLinksPage } from './pwa-links-page.js';
import { PwaLinksAdminPanel } from './admin/pwa-links-admin-panel.js';
import { PwaLinksIcon } from './icons.js';
export class PwaLinksClientRegistrar {
    constructor(deps) {
        const { pageRouteRegistry, adminSlots, clientServiceRegistry, pwaLinksApiClient } = deps;
        // 0. 注册 API 客户端到 ClientServiceRegistry（供 React 组件通过 Context 消费）
        clientServiceRegistry.registerService('pwa-links-client', 'pwaLinksApiClient', pwaLinksApiClient);
        // 1. 注册公开导航页面（带 SSR loader）
        pageRouteRegistry.registerPage({
            path: '/pwa-links',
            component: PwaLinksPage,
            key: 'pwa-links',
            meta: {
                title: 'PWA 应用导航',
            },
            modName: 'pwa-links-client',
            loader: async () => {
                const [links, categories] = await Promise.all([
                    pwaLinksApiClient.getPublicLinks({ pageSize: 100 }),
                    pwaLinksApiClient.getCategories(),
                ]);
                return { links, categories };
            },
        });
        // 2. 注册 Admin Slot
        adminSlots.registerSlot({
            id: 'pwa-links-management',
            label: 'PWA 管理',
            icon: PwaLinksIcon,
            component: PwaLinksAdminPanel,
            order: 40,
            modName: 'pwa-links-client',
        });
    }
}
//# sourceMappingURL=pwa-links-client-registrar.js.map